import { useMutation, useQuery } from "@tanstack/react-query";
import {
  fetchSavedSearches,
  removeSavedSearch,
  saveSearch,
  searchProfiles,
} from "api/search";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const useSearchProfiles = (
  { page, limit, filter_data, saved_search_id, keyword },
  options = {},
) => {
  return useQuery({
    queryKey: [
      "searchProfiles",
      { page, limit, filter_data, saved_search_id, keyword },
    ],
    queryFn: () =>
      searchProfiles({
        page,
        limit,
        filter_data,
        saved_search_id,
        keyword,
      }),
    keepPreviousData: true,
    enabled: !!page && !!limit,
    ...options,
  });
};

export const useSaveSearch = (options = {}) => {
  return useMutation({
    mutationFn: saveSearch,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useSavedSearches = (
  { page = 1, limit = 8, search_mode },
  options = {},
) => {
  return useQuery({
    queryKey: ["savedSearches", { page, limit, search_mode }],
    queryFn: ({ queryKey }) => fetchSavedSearches({ queryKey }),
    enabled: !!search_mode,
    ...options,
  });
};

export const useRemoveSavedSearch = (options = {}) => {
  return useMutation({
    mutationFn: removeSavedSearch,
    onSuccess: (data, variables, context) => {
      AlertNotification(
        "success",
        data.message || "Saved search removed successfully",
      );

      options.onSuccess?.(data, variables, context);
    },
  });
};
